import React from 'react';
// import { FormattedRelative, FormattedMessage, defineMessages } from 'react-intl';

import DashBoard from 'src/containers/Dashboard';
import Wrapper from '../src/hoc/Wrapper';
import { AUTH_MAIN } from '../src/utils';

// import withIntl from '../lib/withIntl';

class Index extends React.Component {
    // static async getInitialProps({ req }) {
    // 	return { someDate: Date.now() };
    // }

    render() {
        return (<Wrapper mode={AUTH_MAIN}>
            <DashBoard />
            {/* <p>
						<FormattedRelative value={this.props.someDate} updateInterval={1000} />
					</p>
					<p>
						<FormattedMessage id="description" defaultMessage="Hello, World!" />
					</p> */}
        </Wrapper>);
    }
}

export default Index;
